module.exports = __webpack_public_path__ + "static/media/touch_prompt.3853aa8c.mp3";